import { render } from "./NotificationsModal.vue?vue&type=template&id=2993d129&scoped=true"
import script from "./NotificationsModal.vue?vue&type=script&lang=js"
export * from "./NotificationsModal.vue?vue&type=script&lang=js"

import "./NotificationsModal.vue?vue&type=style&index=0&id=2993d129&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2993d129"]])

export default __exports__